/**
 * Disable scrollbar on document.body
 * Returns a function to enable it back
 */
export function scrollLock() {
    var HIDDEN_VALUE = 'hidden';
    var _a = document.body.style, bodyOverflow = _a.overflow, inlineBodyMarginRight = _a.marginRight;
    var marginLeft = document.defaultView.getComputedStyle(document.body).marginLeft;
    var marginLeftPx = parseInt(marginLeft, 10);
    var bodyOffsetRight = document.defaultView.innerWidth -
        document.body.offsetWidth -
        marginLeftPx;
    document.body.style.overflow = HIDDEN_VALUE;
    document.body.style.marginRight = "".concat(bodyOffsetRight, "px");
    return function () {
        // there is no need to set this value if it is already set
        // but setting a value creates a bug when nesting multiple components using this function, 
        // due to the impossibility of guaranteeing the expected execution order of the 'removeScrollLock' functions
        if (bodyOverflow !== HIDDEN_VALUE) {
            document.body.style.overflow = bodyOverflow;
        }
        document.body.style.marginRight = inlineBodyMarginRight;
    };
}
